// extracted by mini-css-extract-plugin
module.exports = {"statistics":"LeaderboardSummary_statistics__1P6Dd","dates":"LeaderboardSummary_dates__jgs87","heading":"LeaderboardSummary_heading__Wgr7b"};